import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { ConfirmActionButton } from "./ConfirmActionButton";

// TODO: Use this instead of buttons in other pages
interface DeleteButtonProps {
  /** Async delete handler; should return true on success */
  handleDelete: () => Promise<boolean>;
  /** Optional button label, defaults to "Delete" */
  buttonLabel?: string;
  /** Confirmation message, defaults to generic */
  confirmMessage?: string;
  /** If false, skips confirmation modal and deletes immediately */
  requireConfirmation?: boolean;
  disabled?: boolean
  iconOnly?: boolean
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  handleDelete,
  buttonLabel,
  confirmMessage,
  requireConfirmation = true,
  disabled = false,
  iconOnly = false
}) => {
  const { t } = useTranslation();
  const label = buttonLabel ?? t("actions.delete");

  return (
    <ConfirmActionButton
      onAction={handleDelete}
      variant="danger"
      actionLabel={t("actions.delete")}
      mnemonic="d"
      confirmTitle={t("actions.confirmDeletion")}
      confirmMessage={confirmMessage ?? t("actions.confirmDeleteMessage")}
      buttonLabel={iconOnly ? <FontAwesomeIcon icon={faTrash} /> : label}
      requireConfirmation={requireConfirmation}
      disabled={disabled}
      className={iconOnly ? "!px-3 !py-1 text-sm" : ""}
      title={iconOnly ? label : undefined}
    />
  );
};

export default DeleteButton;
